export const colors: string[] = [
    "Rojo",
    "Azul",
    "Verde",
    "Amarillo",
    "Naranja",
    "Morado",
    "Rosa",
    "Marrón",
    "Negro",
    "Blanco",
    "Gris",
    "Celeste",
    "Turquesa",
    "Violeta",
    "Lila",
    "Fucsia",
    "Cian",
    "Magenta",
    "Carmesí",
    "Coral",
    "Oliva",
    "Azul Marino",
    "Mostaza",
    "Champán",
    "Salmón",
    "Lavanda",
    "Beige",
    "Caqui",
    "Granate",
    "Verde Lima",
    "Ámbar",
    "Azul cielo",
    "Café",
    "Arena",
    "Plata",
    "Otro",
]
